import { createFileRoute } from '@tanstack/react-router';
import EmployeeProfileView from '@features/employees/EmployeeProfileView';

export const Route = createFileRoute('/t/employees/profile/$employeeId')({
  staticData: { breadcrumb: 'Employee Profile', breadcrumbKey: 'K_BREADCRUMB_EMPLOYEE_PROFILE' },
  component: EmployeeProfilePage,
});

function EmployeeProfilePage() {
  const { employeeId } = Route.useParams();

  return (
    <EmployeeProfileView employeeId={employeeId} />
  );
}
